import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { exportToCsv } from "@/lib/reportExport";
import { exportToExcel } from "@/lib/reportExport";

interface Props {
  getData: () => Record<string, unknown>[];
  filePrefix: string;
  onPrintPdf?: () => void;
}

export default function ExportDropdown({ getData, filePrefix, onPrintPdf }: Props) {
  const { t } = useTranslation("admin");
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline" className="gap-1.5">
          <Download className="h-3.5 w-3.5" /> {t("reports.export.export")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => exportToCsv(`${filePrefix}.csv`, getData())} className="gap-2">
          <FileText className="h-4 w-4" /> CSV
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => exportToExcel(`${filePrefix}.xlsx`, getData())} className="gap-2">
          <FileSpreadsheet className="h-4 w-4" /> Excel (.xlsx)
        </DropdownMenuItem>
        {onPrintPdf && (
          <DropdownMenuItem onClick={onPrintPdf} className="gap-2">
            <FileText className="h-4 w-4" /> {t("reports.export.pdfPrint")}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
